import { useLocation, useParams } from "react-router-dom";
import {
  useAppSelector,
  useDebounceValue,
  useStateWithSearchParams,
} from "../../../hooks";
import { useExportDataMutation, useExportListQuery } from "../../../api";
import { Order } from "../../../types";
import { AppRoutes } from "../../../types/enums";
import { accountsTabs } from "../../../types/genereal";
import { QUERY_SEPARATOR } from "../../../constant";
import { ExportCSVModal } from "./ExportCSVModal";

type SearchParams = {
  sizes?: string;
  industries?: string;
  regions?: string;
  search?: string;
  sort?: string;
  page?: string;
  per_page?: string;
  selected?: string;
  limit?: string;
  date?: string;
};

export const ExportAccountsCSVModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const { campaign_id } = useParams();
  const { pathname } = useLocation();
  const currentTab = accountsTabs[pathname.split(AppRoutes.HOME)[2]];

  const campaignId = useAppSelector((state) => state.company.company);

  const { searchDict } = useStateWithSearchParams<SearchParams>({
    industries: undefined,
    regions: undefined,
    sizes: undefined,
    search: undefined,
    page: undefined,
    per_page: undefined,
    selected: undefined,
    limit: undefined,
    date: undefined,
  });

  const querySearchValueDebounce = useDebounceValue(searchDict.search || "");

  const [exportData, { isLoading: isGenerationgCSV }] = useExportDataMutation();

  const { data: companyList, isLoading } = useExportListQuery(
    {
      campaign_id: campaign_id || campaignId,
      limit: searchDict.limit ? Number(searchDict?.limit) : undefined,
      size: searchDict.sizes?.split(QUERY_SEPARATOR),
      search: querySearchValueDebounce || undefined,
      industry: searchDict.industries?.split(QUERY_SEPARATOR),
      region: searchDict.regions?.split(QUERY_SEPARATOR),
      sort: currentTab,
      order: searchDict.sort?.split("-")[1] as Order,
      start_date: searchDict.date?.split(QUERY_SEPARATOR)[0],
      end_date: searchDict.date?.split(QUERY_SEPARATOR)[1],
    },
    { refetchOnMountOrArgChange: true },
  );

  const submitHandler = (account_ids: string[], fileName: string) => {
    return exportData({
      campaign_id: campaign_id || campaignId,
      file_name: fileName.trim() || undefined,
      account_ids,
      only_committee: true,
      filters: {
        limit: searchDict.limit ? Number(searchDict?.limit) : undefined,
        size: searchDict.sizes?.split(QUERY_SEPARATOR),
        search: searchDict.search,
        industry: searchDict.industries?.split(QUERY_SEPARATOR),
        region: searchDict.regions?.split(QUERY_SEPARATOR),
        sort: currentTab,
        order: searchDict.sort?.split("-")[1] as Order,
        start_date: searchDict.date?.split(QUERY_SEPARATOR)[0],
        end_date: searchDict.date?.split(QUERY_SEPARATOR)[1],
      },
    }).unwrap();
  };

  return (
    <ExportCSVModal
      title={"Export Data to CSV"}
      description={
        "Which data set of discovered buying committee members you would like to export?"
      }
      items={companyList || []}
      isLoading={isLoading || isGenerationgCSV}
      onSubmit={submitHandler}
      onClose={onClose}
      submitBtnText={"Export Reports"}
    />
  );
};
